import { Col, Divider, Row } from "antd";
import GeneralViewPanel from "./panel";

export default function GeneralView(){

    return(
        <Row>
            <Col lg={24} xs={24}>
                <div style={{ fontSize: '1.1em', fontWeight: 'bold' }}>Vista General</div>
                <Divider />
                <GeneralViewPanel />
            </Col>
        </Row>
    );
}